import { render } from "./NotificationBell.vue?vue&type=template&id=0e1d9cc8&scoped=true"
import script from "./NotificationBell.vue?vue&type=script&lang=js"
export * from "./NotificationBell.vue?vue&type=script&lang=js"

import "./NotificationBell.vue?vue&type=style&index=0&id=0e1d9cc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1d9cc8"]])

export default __exports__